<div class="container">
  <div class="row">
    <div class="col-9 mt-3 mb-5 py-5 mx-auto">

      <h1>Create An Account</h1>
      <p>Please fill out the information below to create a secure account.</p>

      <app-registration-form></app-registration-form>

    </div>
  </div>
</div>

